// const filters = [
//   {
//     name: 'accountNumber',
//     validationType: '',
//     func: function (value) {
//       if (!value) return
//       return value.replace(/(\d{4})(\d{2}x{2})(x{4})(\d{4})/i, '$1 $3 $3 $4').replace(/x/gi, '*')
//     }
//   },
//   {
//     name: 'accountNumberShown',
//     validationType: 'pan',
//     func: function (value) {
//       if (!value) return
//       let cardCode = value.replace(/[^\d]/g, '');
//       cardCode = cardCode !== '' ? cardCode.match(/.{1,4}/g).join(' ') : '';
//       return cardCode;
//     }
//   },
//   {
//     name: 'orderType',
//     validationType: '',
//     func: function (value) {
//       switch (value) {
//         case 'PAYOUT': return 'Вывод:'
//         case 'PURCHASE': return 'Заказ:'
//         case 'PURCHASE_BILL': return 'Оплата счёта:'
//         case 'BILL': return 'Открытый счёт'
//         default: return value
//       }
//     }
//   },
// ]

// const computedFilters = [
//   {
//     name: 'getFilter',
//     func: function(value, filterName) {
//       let f = filters.find(el => el.validationType === filterName);
//       return f && f.func(value);
//     }
//   }
// ]

// export default filters.concat(computedFilters);

export default [];
